import React from "react";

const CATEGORY_MAPPINGS = {
  timeControl: "Zaman yönetimi ve iş teslimatları",
  communication: "İletişim ve takım çalışması",
  problemSolving: "Problem çözme ve yaratıcılık",
  improvement: "Geri bildirim ve kişisel gelişim",
  initiative: "Bağımsız Çalışabilme ve İnisiyatif",
};

const RatingScale = ({
  category,
  selected,
  handleRatingChange,
  page,
  disabled,
}) => {
  const displayCategory = CATEGORY_MAPPINGS[category] || category;

  return (
    <div className="flex items-center justify-between py-4 relative">
      <span
        className={`text-xs text-dark font-normal ${
          page === "hesabim" ? "hidden" : "block"
        }`}
      >
        Çok Kötü
      </span>
      <div className="flex flex-1 justify-between items-center mx-4 relative">
        <div className="absolute top-1/2 left-0 right-0 h-[2px] flex">
          <div
            className="h-[2px] border-t-2 border-dashed border-darkerGreen transition-all"
            style={{ width: `${(selected - 1) * 25}%` }}
          ></div>
          <div className="h-[2px] border-t-2 border-dashed border-gray-300 transition-all flex-1"></div>
        </div>
        {[1, 2, 3, 4, 5].map((num) => (
          <label
            key={num}
            className={`relative flex flex-col items-center ${
              disabled ? "cursor-default pointer-events-none" : "cursor-pointer"
            }`}
          >
            <input
              type="radio"
              name={displayCategory}
              value={num}
              checked={selected === num}
              onChange={() => {
                if (!disabled) {
                  handleRatingChange(category, num);
                }
              }}
              disabled={disabled}
              className="hidden"
            />
            <div
              className={`w-[16px] h-[16px] sm:w-[22px] sm:h-[22px] border-2 rounded-full grid place-items-center transition-all ${
                selected >= num
                  ? "border-darkerGreen bg-whiteBg"
                  : "border-gray-400 bg-whiteBg"
              }`}
            >
              <div
                className={`w-[10px] h-[10px] sm:w-[13px] sm:h-[13px] rounded-full flex items-center justify-center transition-all border-2 ${
                  selected >= num
                    ? "bg-darkerGreen border-darkerGreen"
                    : "bg-white border-gray-400"
                }`}
              ></div>
            </div>
          </label>
        ))}
      </div>
      <span
        className={`text-xs text-dark font-normal ${
          page === "hesabim" ? "hidden" : "block"
        }`}
      >
        Mükemmel
      </span>
    </div>
  );
};

export default RatingScale;
